import { render, staticRenderFns } from "./CustomFieldDateTimeEditor.vue?vue&type=template&id=252a2120&"
import script from "./CustomFieldDateTimeEditorVue.ts?vue&type=script&lang=ts&"
export * from "./CustomFieldDateTimeEditorVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports